import Client from './client';

export default class Compliances extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/compliance`, options);
  }

  getTypeAndDestinationByTypeAndDestination(organization, type, destination, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/compliance/type/${type}/destination/${destination}`, options);
  }

  putTypeAndDestinationByTypeAndDestination(organization, type, destination, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/compliance/type/${type}/destination/${destination}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteTypeAndDestinationByTypeAndDestination(organization, type, destination, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/compliance/type/${type}/destination/${destination}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
